module.exports = __webpack_public_path__ + "static/media/arrow.b0948c06.svg";